import { render, staticRenderFns } from "./CurrencyForm.vue?vue&type=template&id=1bf254c9&scoped=true&"
import script from "./CurrencyForm.vue?vue&type=script&lang=js&"
export * from "./CurrencyForm.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyForm.vue?vue&type=style&index=0&id=1bf254c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf254c9",
  null
  
)

export default component.exports